export default __webpack_public_path__ + "static/media/icon_dropdownArrow.7be2611c.svg";